<template>
  <div class="detail_content">
    <div class="detail_label">
      {{ titleLabel }}
    </div>
    <div class="callApp">
      <table class="table_header" border="1" cellpadding="2" bordercolor="#fff" style="border-collapse: collapse; border: solid 1px #000000">
        <tr>
          <th class="cell_ID">ID</th>
          <th class="cell_callAppName">アプリ名</th>
        </tr>
        <tr v-for="callApp in callAppList" :key="callApp.id" class="item_callApp_table_row">
          <td class="cell_ID">
            {{ callApp.id }}
          </td>
          <td class="cell_callAppName">
            {{ callApp.callAppName }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String,
    callAppList: Array
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.callApp {
  max-height: 550px;
  width: calc(100% - 60px);
  overflow-y: scroll;
}
ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.item_callApp_table_row {
  height: 40px;
  background-color: #fff;
  color: #4a4a4a;
}
.cell_ID {
  width: 30px;
}
.cell_callAppName {
  width: 230px;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/callAppListSection.vue